import { connect, useDispatch } from "react-redux";
import LoadingDialog from "../../components/Common/LoadingDialog";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/Form/CustomButton";
import { acceptInvitation } from "../../store/actions";

const AcceptInvitation = ({ invitationRes }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setIsLoading] = React.useState(true);
    const expires = new URLSearchParams(window.location.search).get("expires");
    const invitation = new URLSearchParams(window.location.search).get("invitation");
    const signature = new URLSearchParams(window.location.search).get("signature");

    useEffect(() => {
        if (expires && invitation && signature) {
            setIsLoading(true);
            dispatch(acceptInvitation({ expires: expires, invitation: invitation, signature: signature }));
        }
    }, [expires, invitation, signature])

    useEffect(() => {
        if (invitationRes?.code === 'success') {
            setIsLoading(false);
        } else if (invitationRes?.code === 'error') {
            setIsLoading(false);
        }
    }, [invitationRes])

    return (
        <div style={{ height: '100vh', fontSynthesis: 'none' }} className="d-flex align-items-center justify-content-center">
            <LoadingDialog open={loading || !(expires && invitation && signature)} />
            <div style={{ textAlign: 'center' }}>
                {
                    invitationRes?.code === 'error' &&
                    <>
                        <div className="text-bold font-size-24 mb-2">{invitationRes?.message || 'Failed to accept invitation'}</div>
                        <CustomButton
                            title={'Back to Login'}
                            press={() => navigate("/login")}
                        />
                    </>
                }
                {
                    invitationRes?.code === 'success' &&
                    <>
                        <div className="text-bold font-size-24">{invitationRes?.message || 'Successfully accepted invitation'}</div>
                        <CustomButton
                            title={'Back to Login'}
                            press={() => navigate("/login")}
                        />
                    </>
                }

            </div>
        </div>
    )
}

function mapStateToProps({ General }) {
    return {
        invitationRes: General.acceptInvitationRes,
    };
}


export default connect(mapStateToProps)(AcceptInvitation);